// HEAD DATA
export const headData = {
  title: 'Health Massage & Beauty Algarve',
  titleBlog: 'Blog - Health Massage & Beauty Algarve',
  lang: 'en',
  description:
    'Mobile Massage and Beauty services available over all the Algarve. We will make your home more relaxing with best Masseurs and Beauticians.',
};